"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.intersectionInit = exports.handleMoney = exports.APP_TYPE_MAP = void 0;
const tslib_1 = require("tslib");
/* eslint-disable @typescript-eslint/no-magic-numbers */
const bignumber_js_1 = tslib_1.__importDefault(require("bignumber.js"));
const { useLang } = require('@fegobull/webapi').use;
const LANG = {
    EN: 2,
    CN: 0,
    JP: 5,
    HK: 1
};
const APP_TYPE_MAP = {
    NN: 'nn',
    MOOMOO: 'moomoo'
};
exports.APP_TYPE_MAP = APP_TYPE_MAP;
const useIsEN = () => {
    const { lang } = useLang();
    return lang === LANG.EN;
};
const useIsJP = () => {
    const { lang } = useLang();
    return lang === LANG.JP;
};
const ueseIsHK = () => {
    const { lang } = useLang();
    return lang === LANG.HK;
};
const isEN = useIsEN();
const isJP = useIsJP();
const isHK = ueseIsHK();
/**
 * 到视区再加载函数
 * @param {Object} el 视区节点
 * @param {String} fn 初始化数据
 * @param {Object} inited 数据是否已经加载
 * @returns void
 */
const intersectionInit = (el, fn, inited) => {
    try {
        const observer = new IntersectionObserver((IoEntity) => {
            const isShow = IoEntity === null || IoEntity === void 0 ? void 0 : IoEntity.find((item) => item.intersectionRatio > 0);
            // intersectionRatio目标元素的可见比例，完全可见时为1，完全不可见时小于等于0
            if (isShow && !inited.value) {
                fn();
            }
        });
        observer.observe(el);
    }
    catch (error) {
        fn();
    }
};
exports.intersectionInit = intersectionInit;
const handleMoney = (numori) => {
    const numBN = new bignumber_js_1.default(numori).abs();
    const num = numBN.toNumber();
    const data = {
        txt: '0',
        unit: '',
        num: '0',
        miuns: new bignumber_js_1.default(numori).isLessThan(0)
    };
    if (isEN) {
        if (num >= 1e9) {
            data.num = numBN.dividedBy(1e7).integerValue(bignumber_js_1.default.ROUND_FLOOR).dividedBy(1e2).toFixed(2);
            data.unit = 'B';
        }
        else if (num >= 1e6) {
            data.num = numBN.dividedBy(1e4).integerValue(bignumber_js_1.default.ROUND_FLOOR).dividedBy(1e2).toFixed(2);
            data.unit = 'M';
        }
        else {
            data.num = numBN.dividedBy(10).integerValue(bignumber_js_1.default.ROUND_FLOOR).dividedBy(1e2).toFixed(2);
            data.unit = 'K';
        }
    }
    else if (num >= 1e8) {
        data.num = numBN.dividedBy(1e6).integerValue(bignumber_js_1.default.ROUND_FLOOR).dividedBy(1e2).toFixed(2);
        data.unit = isJP || isHK ? '億' : '亿';
    }
    else {
        data.num = numBN.dividedBy(1e2).integerValue(bignumber_js_1.default.ROUND_FLOOR).dividedBy(1e2).toFixed(2);
        data.unit = '万';
    }
    if (data.miuns) {
        data.txt = `-${data.txt}${data.unit}`;
    }
    data.txt = `${data.num}${data.unit}`;
    return data;
};
exports.handleMoney = handleMoney;
//# sourceMappingURL=data:application/json;base64,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